import { useCallback } from 'react';
import { HosLogObject } from '../types';
import { Moment } from 'moment';

export const useGetIsCurrentStatus = (
  today: Moment,
  hosLogObject: HosLogObject,
): ((index: number) => boolean) =>
  useCallback(
    (index: number): boolean => {
      const { hosGridObject, fmcsaLogDate } = hosLogObject;
      return index === hosGridObject.length - 1 && today.format('YYYY-MM-DD') === fmcsaLogDate;
    },
    [hosLogObject, today],
  );
